import VanillaTilt from 'vanilla-tilt';
import {
  _,
  each
} from 'lodash';
import ScrollReveal from 'scrollreveal';
import {
  config
} from './../config';
const Log = function(param) {
  if (config.debug) {
    console.log(param);
  }
};
const Warn = function(param) {
  if (config.debug) {
    console.warn(param);
  }
};
const animations = {
  tilt(config) {
    Log(['starting new tilt']);
    if (!config.target) {
      Warn(['anime_tilt : no target']);
      return false;
    }
    var tilter = VanillaTilt.init(document.querySelector(config.target), {
      reverse: config.reverse ? config.reverse : false, // reverse the tilt direction
      max: config.max ? config.max : 35, // max tilt rotation (degrees)
      perspective: config.perspective ? config.perspective : 1000, // Transform perspective, the lower the more extreme the tilt gets.
      scale: config.scale ? config.scale : 1, // 2 = 200%, 1.5 = 150%, etc..
      speed: config.speed ? config.speed : 300, // Speed of the enter/exit transition
      transition: config.transition ? config.transition : true, // Set a transition on enter/exit.
      axis: config.axis ? config.axis : null, // What axis should be disabled. Can be X or Y.
      reset: config.reset ? config.reset : true, // If the tilt effect has to be reset on exit.
      easing: config.easing ? config.easing : 'cubic-bezier(.03,.98,.52,.99)', // Easing on enter/exit.
      glare: config.glare ? config.glare : false, // if it should have a "glare" effect
      'max-glare': config.maxGlare ? config.maxGlare : 1, // the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
      'glare-prerender': config.glarePrerender ? config.glarePrerender : false // false = VanillaTilt creates the glare elements for you, otherwise
    });
    return tilter;
  },
  scrollReveal(config) {
    var els = document.querySelectorAll(config.target);
    var sr = ScrollReveal();
    var animation = function() {
      var index = 0,
        from;
      _.each(els, function(el) {
        if (config.shift) {
          index = index + 1;
          if (index % 2) {
            from = 'right';
          } else {
            from = 'left';
          }
        } else {
          from = config.from ? config.from : 'left';
        }
        var currentEl = sr.reveal(el, {
          // 'bottom', 'left', 'top', 'right'
          origin: from,

          // Can be any valid CSS distance, e.g. '5rem', '10%', '20vw', etc.
          distance: config.distance ? config.distance : '100vw',

          // Time in milliseconds.
          duration: config.duration ? config.duration : 500,
          delay: 0,

          // Starting angles in degrees, will transition from these values to 0 in all axes.
          rotate: {
            x: 0,
            y: 0,
            z: 0
          },

          // Starting opacity value, before transitioning to the computed opacity.
          opacity: 0,

          // Starting scale value, will transition from this value to 1
          scale: config.scale ? config.scale : 1,

          // Accepts any valid CSS easing, e.g. 'ease', 'ease-in-out', 'linear', etc.
          easing: config.easing ? config.easing : 'cubic-bezier(0.2, 0.6, 0.4, 1)',

          // `<html>` is the default reveal container. You can pass either:
          // DOM Node, e.g. document.querySelector('.fooContainer')
          // Selector, e.g. '.fooContainer'
          container: window.document.documentElement,

          // true/false to control reveal animations on mobile.
          mobile: true,

          // true:  reveals occur every time elements become visible
          // false: reveals occur once as elements become visible
          reset: false,

          // 'always' — delay for all reveal animations
          // 'once'   — delay only the first time reveals occur
          // 'onload' - delay only for animations triggered by first load
          useDelay: 'always',

          // Change when an element is considered in the viewport. The default value
          // of 0.20 means 20% of an element must be visible for its reveal to occur.
          viewFactor: 0.2,

          // Pixel values that alter the container boundaries.
          // e.g. Set `{ top: 48 }`, if you have a 48px tall fixed toolbar.
          // --
          // Visual Aid: https://scrollrevealjs.org/assets/viewoffset.png
          viewOffset: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },

          // Callbacks that fire for each triggered element reveal, and reset.
          beforeReveal: function(domEl) {},
          beforeReset: function(domEl) {},

          // Callbacks that fire for each completed element reveal, and reset.
          afterReveal: function(domEl) {},
          afterReset: function(domEl) {}
        });
      });
    };
    window.sr = window.requestAnimationFrame(animation);
  },
  smoothScroll() {
    var body = document.body;
    var ticking, scrollpoz, timer;
    var perfScroll = function () {
      clearTimeout(timer);
      if (!body.classList.contains('disable-hover')) {
        body.classList.add('disable-hover');
      }
      timer = setTimeout(function() {
        body.classList.remove('disable-hover');
      }, 150);
    };

    window.addEventListener('scroll', function(e) {
      scrollpoz = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function() {
          perfScroll();
          ticking = false;
        });
      }
      ticking = true;
    });
  }
};

export {
  animations
};
